import type { ComponentPropsWithoutRef } from 'react'

import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'
import { ChevronDown } from '@/lib/icons'

export const FIELD =
  'font-body text-body-md text-fg glass border-glass-border bg-surface-container-low placeholder:text-fg-muted w-full rounded-md border px-4 py-3 outline-none focus:border-primary-container/50 disabled:opacity-50'

export const LABEL = 'font-body text-label-caps text-fg-muted uppercase'

const SELECT = cn(FIELD, 'appearance-none bg-none pr-11')

export function FieldSelect({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<'select'>) {
  return (
    <div className="relative">
      <select className={cn(SELECT, className)} {...rest}>
        {children}
      </select>
      <Icon
        icon={ChevronDown}
        className="text-fg-muted pointer-events-none absolute top-1/2 right-3.5 size-4 -translate-y-1/2"
      />
    </div>
  )
}
